Wee.fn.make('contact', {
	init: function() {
		var $form = $('#contactform123');

		$form.height(1500);
	}
});